<script setup lang="ts" generic="T extends string | number = string">
import { TabsRoot, type TabsRootEmits, type TabsRootProps, useForwardPropsEmits } from 'reka-ui';

const props = defineProps<TabsRootProps<T>>();
const emits = defineEmits<TabsRootEmits<T>>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <TabsRoot v-bind="forwarded">
    <slot />
  </TabsRoot>
</template>
